import { AvatarType } from '$types/avatarType';

export enum UserType {
  HUMAN = 'human',
  GROUP = 'group',
  ORG = 'org',
  SIGNUP = 'signup',
  INVITE = 'invite',
  MIGRATING = 'migrating',
  UNKNOWN = 'unknown',
}

export const mapAvatarTypeToUserType = (avatarType: AvatarType | undefined): UserType => {
  switch (avatarType) {
    case 'Signup':
      return UserType.SIGNUP;
    case 'OrganizationSignup':
      return UserType.ORG;
    case 'RegisterHuman':
      return UserType.HUMAN;
    case 'Invite':
      return UserType.INVITE;
    case 'RegisterGroup':
      return UserType.GROUP;
    case 'RegisterOrganization':
      return UserType.ORG;
    case 'Migrating':
      return UserType.MIGRATING;
    case 'Unknown':
    default:
      return UserType.UNKNOWN;
  }
};
